import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
import { Clock, Frown, DollarSign, UtensilsCrossed, TrendingDown, Moon } from 'lucide-react';
const problems = [{
  icon: Clock,
  text: 'Jornadas interminables'
}, {
  icon: Frown,
  text: 'Estrés constante'
}, {
  icon: DollarSign,
  text: 'Salarios limitados'
}, {
  icon: UtensilsCrossed,
  text: 'Trabajar mientras todos descansan'
}, {
  icon: TrendingDown,
  text: 'Poco crecimiento'
}, {
  icon: Moon,
  text: 'Llegar agotado todos los días'
}];
export function ProblemSection() {
  return <section className="py-16 bg-background relative overflow-hidden" data-id="element-153">
      <div className="px-5 relative z-10" data-id="element-154">
        <motion.div className="text-center mb-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-155">
          <h2 className="text-3xl font-bold text-white font-heading mb-3" data-id="element-156">
            ¿Te suena familiar?
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto rounded-full" data-id="element-157"></div>
        </motion.div>

        <div className="space-y-3" data-id="element-158">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} data-id="element-159">
              <Card className="bg-secondary/50 border-border/50" data-id="element-160">
                <CardContent className="p-4 flex items-center gap-4" data-id="element-161">
                  <div className="p-2.5 rounded-xl bg-primary/10 text-primary shrink-0" data-id="element-162">
                    <problem.icon className="w-5 h-5" data-id="element-163" />
                  </div>
                  <p className="text-white/90 font-medium text-base" data-id="element-164">
                    {problem.text}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>

        <motion.div className="mt-12 text-center space-y-4" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-165">
          <p className="text-xl text-white/90 font-heading leading-relaxed" data-id="element-166">
            Tu problema probablemente{' '}
            <span className="text-primary font-bold" data-id="element-167">
              no sea la gastronomía.
            </span>
          </p>
          <p className="text-base text-white/70" data-id="element-168">
            Tu problema puede ser estar usando tu talento en la industria
            equivocada.
          </p>
        </motion.div>
      </div>
    </section>;
}